module.exports = __webpack_public_path__ + "media/landing_page/good-morning-america-logo-fa921550.svg";